module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "persistent": "",
      "width": "783px"
    },
    on: {
      "input": _vm.sendValue
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline py-2 pl-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-left": ""
    }
  }, [_c('p', {
    staticClass: "headline-title"
  }, [_vm._v("\n\t\t\t\t\t\tVisualizar reserva\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-right": "",
      "pl-0": ""
    }
  }, [_c('label', {
    staticClass: "headline-label"
  }, [_vm._v("\n\t\t\t\t\t\tBooking ID:\n\t\t\t\t\t")]), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.model.numReservation) + "\n\t\t\t\t")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "grey",
      "icon": ""
    },
    on: {
      "click": _vm.closeBookingModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "bar-data"
  }, [_c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\tFecha de reserva:\n\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.model.bookingDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\tLlegada:\n\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.model.bookingStart)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\tSalida:\n\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.model.bookingEnd)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\tNoches:\n\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.model.numberNights))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item no-border"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\t\t\tHuésped:\n\t\t\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.model.quantity))])])])])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "px-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "ml-1": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goToCheckIn(_vm.subsidiaryId, _vm.model.entityId)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tEditar Clientes\n\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": "",
      "text-xs-left": "",
      "px-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\tNº Tarjeta\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v(_vm._s(_vm.getObjectProp(_vm.model, 'customer', 'cardVip')))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\tTipo de identificación\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getObjectProp(_vm.model, 'customer', 'documentName')) + ":\n\t\t\t\t\t\t" + _vm._s(_vm.getObjectProp(_vm.model, 'customer', 'numDocument')) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\tApellidos y Nombres\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.getObjectProp(_vm.model, 'customer', 'lastname')) + ",\n\t\t\t\t\t\t" + _vm._s(_vm.getObjectProp(_vm.model, 'customer', 'name')) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label"
  }, [_vm._v("\n\t\t\t\t\t\tCorreo electrónico\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "modal-text mt-2"
  }, [_vm._v(_vm._s(_vm.getObjectProp(_vm.model, 'customer', 'email')))])])], 1), _vm._v(" "), (_vm.model.customerAditional) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "pl-5": "",
      "mb-1": ""
    }
  }, [_c('label', [_vm._v("Huéspedes adicionales:")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.model.customerAditional), function(customerAditional) {
    return _c('v-layout', {
      key: customerAditional.id,
      attrs: {
        "row": "",
        "wrap": "",
        "mb-4": "",
        "text-xs-left": "",
        "px-5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\tTipo de identificación\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(customerAditional.documentName) + ":\n\t\t\t\t\t\t" + _vm._s(customerAditional.numDocument) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\tApellidos y Nombres\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(customerAditional.lastname) + ",\n\t\t\t\t\t\t" + _vm._s(customerAditional.name) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('p', {
      staticClass: "modal-text mt-4"
    }, [_vm._v(_vm._s(customerAditional.flagPerson))])])], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider')], 1)], 1), _vm._v(" "), (_vm.model.channel) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "my-4": "",
      "text-xs-left": "",
      "px-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mb-3": ""
    }
  }, [_c('label', {
    staticClass: "modal-label pr-2"
  }, [_vm._v("Segmento:")]), _vm._v(" "), _c('span', {
    staticClass: "modal-text"
  }, [_vm._v(_vm._s(_vm.getObjectProp(_vm.model, 'channel', 'name')))])]), _vm._v(" "), _vm._l((_vm.model.channel.data.questions), function(value, key) {
    return _c('v-flex', {
      key: key,
      attrs: {
        "xs2": "",
        "mr-3": ""
      }
    }, [_c('label', {
      staticClass: "modal-label"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(key) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
      staticClass: "modal-text mt-2"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(value) + "\n\t\t\t\t\t")])])
  })], 2) : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "pr-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-cancel grey",
    nativeOn: {
      "click": function($event) {
        _vm.closeBookingModal($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tCerrar\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "pl-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-success white--text",
    nativeOn: {
      "click": function($event) {
        _vm.goToUpdateBooking($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tEditar\n\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-610c8862","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/bookings/sub-component/MenuVisualize.vue
// module id = 1648
// module chunks = 21